import { useEffect, useRef } from 'react';
import { getCrmChatSockJsUrl } from '@/config/chat-ws';
import { parseQstatPhoneUsersEvent, QSTAT_PHONE_USERS_TOPIC, } from '@/shared/model/qstat-phone-users-event.model';
import { acquireCrmStompSharedConnection, onCrmStompSharedConnect, releaseCrmStompSharedConnection, subscribeCrmStompSharedTopic, } from '@/shared/ws/crmStompSharedClient';
/**
 * Subscribes to `/topic/qstat.phone-users` for live status / idleTime / isPhonePause patches.
 */
export function useQstatPhoneUsersTopicSubscription({ enabled = true, sockJsUrl = getCrmChatSockJsUrl(), onEvent, }) {
    const onEventRef = useRef(onEvent);
    onEventRef.current = onEvent;
    useEffect(() => {
        if (!enabled)
            return undefined;
        acquireCrmStompSharedConnection(sockJsUrl);
        const handleMessage = (frame) => {
            const event = parseQstatPhoneUsersEvent(frame.body);
            if (!event)
                return;
            onEventRef.current?.(event);
        };
        const unsubscribeTopic = subscribeCrmStompSharedTopic(QSTAT_PHONE_USERS_TOPIC, handleMessage);
        const detachConnect = onCrmStompSharedConnect(() => {
            /* shared client re-subscribes all topics on connect */
        });
        return () => {
            detachConnect();
            unsubscribeTopic();
            releaseCrmStompSharedConnection();
        };
    }, [enabled, sockJsUrl]);
}
